<script>
	import FriendsList from './FriendsList.svelte';
	import Greeting from './Greeting.svelte';
	import ProfileImage from './ProfileImage.svelte';
	import Login from './Login.svelte';
	import SignOutButton from './SignOutButton.svelte';
	import BasicAddFriend from './BasicAddFriend.svelte';
	import IncomingFriendRequests from './IncomingFriendRequests.svelte';
	import OutgoingFriendRequests from './OutgoingFriendRequests.svelte';
	import { accessToken, user } from '../stores';
	import { auth, db } from '../firebase';
	import firebase from 'firebase/app';

	// const evtSource = new EventSource('https://localhost:8080/test');
	// evtSource.onmessage = function(e) {
	// 	console.log(`New message: ${e.data}`);
	// 	console.log(e);
	// }
	
	$: incomingRequests = [];
	$: outgoingRequests = [];
	$: friends = [];

	$: if ($user) {
		updateRequestsAndFriends();
	}

	// TODO: make better
	function updateRequestsAndFriends() {
		const tempFriends = [];
		const tempIncomingRequests = [];
		const incomingRequestsTasks = [];  // promises for getting documents for users who have sent us friend requests
		// Maybe do this in the store..?  store it as user.friends and user.friendRequests
		// Look into derived stores for friends list?  https://github.com/sveltejs/svelte/issues/2118
		// TODO: is there a way to listen to this query for realtime updates
		// Maybe do this server-side and then send SSEs whenever there's changes?  Listen to ALL users?  Maybe just for activity and other stuff?
		db.collectionGroup('friends').where('friendId', '==', $user.uid)
		.get()
		.then(querySnapshot => {
			console.log(`Looking for friends!!1, found ${querySnapshot.empty ? 'none' : 'some'}`);
			querySnapshot.forEach(friendship => {
				// The other user who has us in their friends collection
				if (friendship.ref.parent.parent.parent.id === 'users') {
					// Parent is the user's friends' collection, whose parent is the user
					const friendRef = friendship.ref.parent.parent;
					console.log(`Found ${friendRef.id}`);

					const localFriend = $user.friends.find(f => f.uid === friendRef.id);
					if (localFriend) {
						console.log('It is a friend:');
						console.log(localFriend);
						tempFriends.push(localFriend);
					} else {
						// They have sent us a friend request
						incomingRequestsTasks.push(friendRef.get());
						tempIncomingRequests.push({
							uid: friendRef.id,
							friendship: {  // TODO: extract out to something like makeLocalFriend?  or create a LocalFriend class and construct it
								...friendship.data(),
							},
						});
					}
				} else {
					console.error('Wrong \'friends\' collection:', friendship.ref.path);
				}
			});

			Promise.all(incomingRequestsTasks)
				.then(docs => {
					docs.forEach((friendDoc, i) => {  // TODO: very similar to below, extract!
						if (friendDoc.exists) {
							const localFriend = {
								...tempIncomingRequests[i],
								...friendDoc.data(),
							};
							console.log('It is an incoming friend request.  From: ', localFriend);
							console.log(localFriend);
							tempIncomingRequests[i] = localFriend;
						} else {
							console.log(`Friend ${friendDoc} not found`);
						}
					});

					// $user.friends.forEach(f => {
					// 	if (!friends.includes(f)) {
					// 		requests.push(f);
					// 	}
					// })  // TODO: why does this forEach work and assigning it cause an infinite reactivity loop?!?!
					friends = tempFriends;
					incomingRequests = tempIncomingRequests;
					outgoingRequests = $user.friends.filter(f => {
						return !friends.includes(f)
					});
					console.log('Updated incoming requests');
					console.log(incomingRequests);
					console.log('Updated outgoing requests');
					console.log(outgoingRequests);
					console.log('Updated friends');
					console.log(friends);
				})
				.catch(e => console.log(`Error getting user from incoming friend request: ${e}`));
		})
		.catch(e => console.log(`Error finding mutual friendships: ${e}`));
	}


    // To update a user's profile, see: https://firebase.google.com/docs/auth/web/manage-users

    auth.onAuthStateChanged(authUser => {
        if (authUser) {
            // User is signed in.
            console.log('Signed in:');
			console.log(authUser);

			// Add extra properties from Firestore to the authenticated user
			// discriminator, friends, etc
			const userRef = db.collection('users').doc(authUser.uid);
			const tasks = [];
			tasks.push(userRef.get());
			tasks.push(userRef.collection('friends').get());
			Promise.all(tasks).then(([userDoc, friendsQuerySnapshot]) => {
				if (!userDoc.exists) {
					console.error('User does not exist in Firestore');
					return;
				}

				console.log('userDoc.data()');
				console.log(userDoc.data());

				console.log('friendsQuerySnapshot')
				console.log(friendsQuerySnapshot)
				const friends = [];
				const friendTasks = [];
				friendsQuerySnapshot.forEach(doc => {
					console.log(`Found: ${doc.id}`);
					console.log(doc.data());
					friends.push({
						friendship: {  // TODO: having a different data model here from firestore might get out of hand, for example when getting friends above they won't have the 'friendship' object unless we specifically get the one we built here
							...doc.data(),
						},
					});
					// TODO: only read this data in FriendsList
					friendTasks.push(db.collection('users').doc(doc.id).get());
				});

				Promise.all(friendTasks)
					.then(friendDocs => {
						friendDocs.forEach((friendDoc, i) => {
							if (friendDoc.exists) {
								console.log(`Friend found: ${friendDoc}`);
								friends[i] = {
									...friends[i],
									...friendDoc.data(),
									uid: friendDoc.id,
								};
							} else {
								console.log(`Friend ${friendDoc} not found`);
							}
						});

						console.log('Setting user data to store.  Friends:');
						console.log(friends)
						user.set({
							...userDoc.data(),
							uid: authUser.uid,
							ref: userRef,
							friends,
						});
					});
			})
        } else {
            // No user is signed in.
			console.log('No user is signed in');
			
			user.set(null);
        }
    });

    // console.log(`OUTSIDE: user - ${auth.currentUser}`);
</script>

<style>
</style>

<Greeting/>
{#if !$user}
<Login/>
{:else}
    <!-- {#if $user} -->
        <ProfileImage user={$user}/>
		<BasicAddFriend/>
		<IncomingFriendRequests requests={incomingRequests}/>
		<OutgoingFriendRequests requests={outgoingRequests}/>
        <FriendsList {friends}/>
		<!-- <FriendRequests requests={$user.friendRequests}/> -->
        <!-- <FriendsList friends={$user.friends}/> -->
		<SignOutButton/>
    <!-- {/if} -->
{/if}
